<app-header></app-header>
<div class="eventos-container">
  <div class="eventos-titles">
    <h1 class="principal-title">Selecciona tu mundo virtual</h1>
    <p class="eventos-desc"></p>
  </div>
</div>

<div class="row cards">
  <div class="col-md-4 col-sm-12">
    <mat-card class="card-evento card">
      <div class="superior-line evento-1-line"></div>
      <mat-card-content>
        <p class="title-evento-marketplace">Marketplace</p>
        <div class="inferior-line"></div>
        <p class="descripcion-evento">
          Crea tu propio centro comercial con locales, góndolas, exhibidores y
          espacios personalizados. Permite que tus clientes recorran el mundo 3D
          por medio de un avatar y vayan de compras.
        </p>
        <img
          src="../../../../assets/images/infoverses-experiencia.png"
          alt=""
          class="img-evento"
        />
      </mat-card-content>
      <mat-card-actions>
        <button
          mat-button
          class="btn btn-evento-1"
          (click)="openMarketplaceEventModal()"
        >
        <mat-spinner diameter="35" *ngIf="isLoading"></mat-spinner>
          {{isLoading?" ":"Crear evento"}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="col-md-4 col-sm-12">
    <mat-card class="card-evento card c-p-1">
      <div class="superior-line evento-2-line"></div>
      <mat-card-content>
        <p class="title-evento-ferias">Ferias</p>
        <div class="inferior-line"></div>
        <p class="descripcion-evento">
          Activa tu exposición. Crea y personaliza pabellones, stands y mezanine
          para atender a los visitantes. Permite que los asistentes seleccionen
          su avatar, interactúen con otros y adquieran los productos de cada
          stand.
        </p>
        <img
          src="../../../../assets/images/ferias.png"
          alt=""
          class="img-evento"
        />
      </mat-card-content>
      <mat-card-actions>
        <button
          mat-button
          (click)="openFeriaEventModal()"
          class="btn btn-evento-2"
        >
          <mat-spinner diameter="35" *ngIf="isLoading"></mat-spinner>
          {{isLoading?" ":"Crear evento"}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="col-md-4 col-sm-12">
    <mat-card class="card-evento card c-p-2">
      <div class="superior-line evento-3-line"></div>
      <mat-card-content>
        <p class="title-evento-conferencias">Conferencias</p>
        <div class="inferior-line"></div>
        <p class="descripcion-evento">
          Recibe a la audiencia global en tu conferencia o ceremonia. Cada
          asistente seleccionará su mejor atuendo para la gala y podrá
          interactuar con otros invitados. Las charlas y conferencias se
          trasmiten en tiempo real .
        </p>
        <img
          src="../../../../assets/images/conferencias.png"
          alt=""
          class="img-evento"
        />
      </mat-card-content>
      <mat-card-actions>
        <button disabled mat-button class="btn btn-evento-3">
          Crear evento
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="col-md-4 col-sm-12">
    <mat-card class="card-evento card c-p-2">
      <div class="superior-line evento-4-line"></div>
      <mat-card-content>
        <p class="title-evento-conferencias">Ferias escolares</p>
        <div class="inferior-line"></div>
        <p class="descripcion-evento">
          Activa tu exposición. Crea y personaliza pabellones, stands y mezanine para atender a los visitantes. Permite que los asistentes seleccionen su avatar, interactúen con otros y adquieran los productos de cada stand.
        </p>
        <img
          src="../../../../assets/images/Imagen-escolar.JPG"
          alt=""
          class="img-evento"
        />
      </mat-card-content>
      <mat-card-actions>
        <button mat-button class="btn btn-evento-3" (click)="openFeriaEscolarEventModal()">
          <mat-spinner diameter="35" *ngIf="isLoading"></mat-spinner>
          {{isLoading?" ":"Crear evento"}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="col-md-4 col-sm-12">
    <mat-card class="card-evento card c-p-2">
      <div class="superior-line evento-5-line"></div>
      <mat-card-content>
        <p class="title-evento-conferencias">Aventura de realidad aumentada</p>
        <div class="inferior-line"></div>
        <p class="descripcion-evento">
          Activa tu aventura AR. Crea y personaliza estaciones y minijuegos
          para recibir a los visitantes. Permite que los asistentes
          completen las estaciones buscando el marcador correspondiente, 
          ganando puntos y recibiendo recompensas.
        </p>
        <img
          src="../../../../assets/images/imagen-yincana.jpg"
          alt=""
          class="img-evento"
        />
      </mat-card-content>
      <mat-card-actions>
        <button mat-button class="btn btn-evento-3" (click)="openYincanaEventModal()">
          <mat-spinner diameter="35" *ngIf="isLoading"></mat-spinner>
          {{isLoading?" ":"Crear evento"}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <div class="col-md-4 col-sm-12">
    <mat-card class="card-evento card c-p-2">
      <div class="superior-line evento-5-line"></div>
      <mat-card-content>
        <p class="title-evento-conferencias">Mundo personalizado</p>
        <div class="inferior-line"></div>
        <p class="descripcion-evento">
          Crea tu Mundo Virtual que siempre has soñado. Usa tus propios escenarios y activa experiencias únicas e irrepetibles. Te ofrecemos la opción de cargar el modelo 3D del escenario y activar una experiencia de metaverso en tiempo real.
        </p>
        <img
          src="../../../../assets/images/ferias.png"
          alt=""
          class="img-evento"
        />
      </mat-card-content>
      <mat-card-actions>
        <button mat-button class="btn btn-evento-3" (click)="openFeriaPersonalizadaEventModal()">
          <mat-spinner diameter="35" *ngIf="isLoading"></mat-spinner>
          {{isLoading?" ":"Crear evento"}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>

<app-footer></app-footer>
